import { Link as SpectrumLink } from '@adobe/react-spectrum';

export type target = '_blank' | '_self';

interface LinkProps {
  url: string;
  target?: target;
  children: React.ReactNode;
}

export const Link = (props: LinkProps) => {
  const { url, target = '_blank', children } = props;
  return (
    <SpectrumLink>
      <a href={url} target={target} rel="noreferrer">
        {children}
      </a>
    </SpectrumLink>
  );
};
